import { SxProps } from '@mui/material';

export const ButtonStyles: SxProps = {
    fontFamily: 'Inter',
    fontSize: '16px',
    fontWeight: '500',
    padding: '16px 24px',
    width: '83%',
    '@media (max-width: 1200px)': {
        width: '100%',
    },
};

export const TypographyStyles: SxProps = {
    marginTop: '30px',
    marginBottom: '30px',
};

export const BoxStyles: SxProps = {
    marginTop: '16px',
};
